
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43 43"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.032 12.422H11.604c-.847 0-1.516.685-1.516 1.521v12.994c0 .85.682 1.521 1.516 1.521h19.428c.846 0 1.515-.684 1.515-1.521V13.943a1.507 1.507 0 00-1.515-1.52z","fill":"#F2994A"}}),_c('path',{attrs:{"d":"M27.52 30.664H15.102a1.41 1.41 0 00-1.402 1.407 1.41 1.41 0 001.402 1.407H27.52a1.41 1.41 0 001.402-1.407c0-.773-.62-1.407-1.402-1.407z","fill":"#FFCEA0"}}),_c('path',{attrs:{"d":"M19.924 28.462v2.206h2.792v-2.206h-2.792z","fill":"#DE8E44"}}),_c('path',{attrs:{"d":"M25.353 21.43c-2.282 0-4.157 1.67-4.367 3.804-.021.22.16.4.38.4h7.974c.221 0 .402-.18.38-.4-.21-2.134-2.084-3.805-4.367-3.805z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"25.353","cy":"18.139","r":"2.559","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.896 18.355c0-.532.602-.852 1.057-.556l2.085 1.36v-.004l2.013 1.308a.655.655 0 010 1.106l-4.098 2.668c-.45.292-1.057-.024-1.057-.556v-5.326z","fill":"#fff"}})])
          )
        }
      }
    